import { render } from "./ChooseCompany.vue?vue&type=template&id=67ea1764&scoped=true"
import script from "./ChooseCompany.vue?vue&type=script&lang=js"
export * from "./ChooseCompany.vue?vue&type=script&lang=js"

import "./ChooseCompany.vue?vue&type=style&index=0&id=67ea1764&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\galita-api\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ea1764"]])

export default __exports__